import Repository from "@shared/services/api/abstracts/Repository";
import { venueBasedUrl } from "@shared/services/api/utils/RepositoryUrlUtils";
import { VenueBaseLocationSerializer } from "../types/seating-types";

export default class VenueBasedLocationRepository extends Repository<
  Array<VenueBaseLocationSerializer>
> {
  public readonly repositoryName = "VenueBasedLocationRepository";

  public readonly endpoint = venueBasedUrl("venues/locations/");
}
